import axios from "axios";
import constants from "constants";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import storage from "services/storage";
// import { toast } from 'react-toastify';
import actions from "actions";
// import validator from 'services/validator.js';
// import validate from 'validate.js';
// import { push } from 'redux-router';

const { updateModalData } = actions;

const {
  SHOW_DASHBOARD_MODAL_SAGA,
  API_DASHBOARDS_USERS,
  UPDATE_MODAL_DATA,
  MODAL_TYPE_DASHBOARD
} = constants;

const apiLoadUsers = (id, type) =>
  axios.get(`${API_DASHBOARDS_USERS}${id}`, {
    params: { statistic_type: type }
  });

function* loadUsers(
  params = { options: { webinar_id, type }, additional: {} }
) {
  const response = yield call(
    apiLoadUsers,
    params.options.webinar_id,
    params.options.type
  );
  const users = response.data.users;
  if (users.length > 0)
    yield put(updateModalData(MODAL_TYPE_DASHBOARD, users, params.additional));
}

// SAGAS
function* __showDashboardModalSaga() {
  yield takeLatest(SHOW_DASHBOARD_MODAL_SAGA, loadUsers);
}

export { __showDashboardModalSaga };



// WEBPACK FOOTER //
// ./src/sagas/admin/dashboard.js